export const getYoutubeThumbnail = (videoId: string, isShorts: boolean) => {
  const url = isShorts
    ? `https://i.ytimg.com/vi/${videoId}/oar1.jpg`
    : `https://img.youtube.com/vi/${videoId}/hqdefault.jpg`;

  const fallbackUrl = isShorts
    ? `https://i.ytimg.com/vi/${videoId}/oar2.jpg`
    : `https://img.youtube.com/vi/${videoId}/maxresdefault.jpg`;

  return {
    url,
    fallbackUrl,
  };
};

export const getYoutubeVideoInfo = (url: string) => {
  let videoId = null;
  let isShorts = false;

  if (url.includes("/shorts/")) {
    videoId = url.split("/shorts/")[1];
    isShorts = true;
    const paramIndex = videoId.indexOf("?");
    if (paramIndex !== -1) {
      videoId = videoId.substring(0, paramIndex);
    }
  } else if (url.includes("youtube.com")) {
    videoId = new URL(url).searchParams.get("v");
  } else if (url.includes("youtu.be")) {
    videoId = url.split("/").pop();
  }

  if (!videoId) return null;

  return {
    videoId,
    isShorts,
    thumbnailUrl: getYoutubeThumbnail(videoId, isShorts),
    embedUrl: `https://www.youtube.com/embed/${videoId}`,
    videoUrl: `https://www.youtube.com/watch?v=${videoId}`,
  };
};
